import { render, staticRenderFns } from "./FeedFrame.vue?vue&type=template&id=97ad6460&"
import script from "./FeedFrame.vue?vue&type=script&lang=js&"
export * from "./FeedFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports